// Anropen till API:t, typade från OpenAPI-specen (ADR 0062). Token läggs till
// i varje anrop, och ett 401 betyder att inloggningen har gått ut.
import createClient, { type Middleware } from 'openapi-fetch';
import type { paths } from './schema.js';

export type Api = ReturnType<typeof createApi>;

/** Ett svar från API:t som inte gick bra, med statuskoden och problem+json. */
export class ApiFel extends Error {
  constructor(
    readonly status: number,
    readonly problem?: unknown,
  ) {
    super(`API:t svarade ${status}`);
  }
}

export interface ApiOptions {
  /** API:ts adress. Tom lokalt, där Vite skickar /v1 vidare till API:t. */
  baseUrl?: string;
  /** Token till anropet. Kan förnya inloggningen först, om den snart går ut. */
  token: () => string | null | Promise<string | null>;
  /** Anropas när API:t svarar 401. */
  onUtloggad: () => void;
  fetch?: typeof fetch;
}

export function createApi({ baseUrl = '', token, onUtloggad, fetch: f }: ApiOptions) {
  const api = createClient<paths>({ baseUrl, ...(f ? { fetch: f } : {}) });
  const inloggning: Middleware = {
    async onRequest({ request }) {
      const t = await token();
      if (t) request.headers.set('Authorization', `Bearer ${t}`);
      return request;
    },
    onResponse({ response }) {
      if (response.status === 401) onUtloggad();
      return response;
    },
  };
  api.use(inloggning);
  return api;
}

/** Datan i ett svar, eller ett ApiFel. */
export function data<T>(svar: { data?: T; error?: unknown; response: Response }): T {
  if (svar.data === undefined) throw new ApiFel(svar.response.status, svar.error);
  return svar.data;
}
